export default __webpack_public_path__ + "static/media/fontLato400_latin.be36596d.woff2";